export const enum AufzugheldenMetricNames {
  LiftState = 'liftState',
  DoorCycles = 'doorCycles',
  LiftRuns = 'liftRuns',
  DoorOpenings = 'doorOpenings',
  DoorClosings = 'doorClosings',
}
